import type { StatsigUser } from '@statsig/react-bindings';

import { get as getUser } from 'js/lib/user';

import getStableId from './getStableId';

/**
 * StatsigUser factory
 */
const createStatsigUser = (): StatsigUser => {
  const user = getUser();
  return {
    userID: user?.id?.toString(),
    customIDs: { stableID: getStableId() },
  };
};

export default createStatsigUser;
